import React, { useEffect } from "react";
import onlineicon from "../../assets/icons/online-class.svg";
import offlineicon from "../../assets/icons/offline-class.png";
import recordings from "../../assets/icons/recordings.svg";
import group from "../../assets/icons/group.svg";
import tasks from "../../assets/icons/tasks.svg";
import community from "../../assets/icons/community-icon.svg";
import assignments from "../../assets/icons/assignments-icon.svg";
import downloadicon from "../../assets/icons/download.svg";
import placement from "../../assets/icons/placement.svg";
import feedback from "../../assets/icons/feedback.svg";
import revision from "../../assets/icons/revision.svg";
import divider from "../../assets/bg/divider.png";
import classrecordings from "../../assets/icons/class-recordings.svg";
import { Helmet } from "react-helmet";
import "../../../src/assets/css/features.css";

const FeatureCard = ({ icon, title, desc, gradient }) => {
  return (
    <div className="premium-feature-card">
      <div className={`premium-overlay ${gradient}`} />
      <div className="premium-card-content">
        <div className="premium-icon-box">
          <img src={icon} alt={title} />
        </div>
        <div>
          <h5 className="premium-title">{title}</h5>
          <p className="premium-desc">{desc}</p>
        </div>
      </div>
      <div className={`premium-bottom-accent ${gradient}`} />
    </div>
  );
};

const FeaturesList = ({ mode, course }) => {
  const Animate = () => {
    const items = document.getElementsByClassName("animate");
    const screenheight = window.innerHeight;
    for (var i = 0; i <= items.length; i++) {
      const currentelement = items[i];
      if (currentelement) {
        const elementposition = parseInt(
          currentelement.getBoundingClientRect().top.toFixed()
        );
        if (elementposition < screenheight) {
          if (!items[i].classList.contains("animation-active")) {
            items[i].classList.add("animation-active");
          }
        }
      }
    }
  };

  useEffect(() => {
    // window.addEventListener("scroll", Animate);
  }, []);

  return (
    <div className="w-100 features-list  premium-features-section">
      <Helmet>
        <title>
          Explore Our Website's Features: Unleash the Full Potential of Your
          Learning Experience - SiliconMinds
        </title>
        <meta
          name="description"
          content="Discover Our Website's Features: Explore a World of Possibilities - From Learning Resources to Interactive Tools."
        />
      </Helmet>

      <div className="text-center premium-header">
        {/* <span className="premium-badge">Why Choose Us?</span> */}
        <h1 className="prime-title-feature text-dark secondary-text">
          Extra-Ordinary <span className="premium-gradient-text">Features</span>
        </h1>
        <h2 className="features-exceptional" style={{color:"#4b515f"}}>For Exceptional Results</h2>

        {/* <div className="premium-divider">
          <img src={divider} alt="divider" />
        </div> */}
      </div>

      <div className="container animate sm-p-0 d-flex flex-wrap justify-content-between">
        {mode === "free" && course.course_category !== "integrated" ? null : (
          <>
            <div className="col-lg-4 col-md-6 col-sm-12 p-3">
              <FeatureCard
                icon={offlineicon}
                title="Offline trainings"
                desc="To learn under our guidance"
                gradient="gradient-orange"
              />
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 p-3">
              <FeatureCard
                icon={onlineicon}
                title="Live online classes"
                desc="To learn from home"
                gradient="gradient-red"
              />
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 p-3">
              <FeatureCard
                icon={classrecordings}
                title="Daily class recordings"
                desc="To revise concepts"
                gradient="gradient-blue"
              />
            </div>
          </>
        )}

        <div className="col-lg-4 col-md-6 col-sm-12 p-3">
          <FeatureCard
            icon={recordings}
            title="Pre-recorded videos"
            desc="Learn anytime, anywhere"
            gradient="gradient-purple"
          />
        </div>

        <div className="col-lg-4 col-md-6 col-sm-12 p-3">
          <FeatureCard
            icon={group}
            title="Group discussions"
            desc="To develop soft skills"
            gradient="gradient-green"
          />
        </div>

        <div className="col-lg-4 col-md-6 col-sm-12 p-3">
          <FeatureCard
            icon={community}
            title="5k+ Students community"
            desc="To learn together"
            gradient="gradient-teal"
          />
        </div>

        <div className="col-lg-4 col-md-6 col-sm-12 p-3">
          <FeatureCard
            icon={tasks}
            title="Teams & group tasks"
            desc="Learn real skills for industry needs"
            gradient="gradient-pink"
          />
        </div>

        <div className="col-lg-4 col-md-6 col-sm-12 p-3">
          <FeatureCard
            icon={revision}
            title="Live course revision"
            desc="To master skills better"
            gradient="gradient-yellow"
          />
        </div>

        <div className="col-lg-4 col-md-6 col-sm-12 p-3">
          <FeatureCard
            icon={assignments}
            title="Assignments & Projects"
            desc="To make you industry ready"
            gradient="gradient-indigo"
          />
        </div>

        <div className="col-lg-4 col-md-6 col-sm-12 p-3">
          <FeatureCard
            icon={feedback}
            title="Individual feedback"
            desc="To improvise your growth"
            gradient="gradient-cyan"
          />
        </div>

        <div className="col-lg-4 col-md-6 col-sm-12 p-3">
          <FeatureCard
            icon={placement}
            title="Placement trainings"
            desc="To easily land your dream job"
            gradient="gradient-orange"
          />
        </div>

        <div className="col-lg-4 col-md-6 col-sm-12 p-3">
          <FeatureCard
            icon={downloadicon}
            title="Downloadable content"
            desc="Learn anywhere, anytime"
            gradient="gradient-red"
          />
        </div>
      </div>
    </div>
  );
};

export default FeaturesList;